<template>
  <div class="box">
    <div class="box-header">
      <h3>Job Detail</h3>
    </div>
    <div class="box-body">
      <div class="grids is-12-desktop gap-20-desktop">
        <div class="field span-10-desktop">
          <label class="label">Job Title</label>
          <div class="control">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" v-model="form.title" class="input" name="Job title" :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field span-2-desktop">
          <label class="label">Staff QTY</label>
          <div class="control">
            <input type="text" v-model="form.staffQTY" class="input" />
          </div>
        </div>
      </div>
      <div class="grids is-2-desktop gap-20-desktop">
        <div class="field" v-if="!jobFunctionLoading">
          <label class="label">Job Function <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Job Function" rules="required" v-slot="{ errors }">
              <selctJobFunction v-model="form.jobFunctionId" :updateText="jobFunctionInfo"
                :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field" v-else-if="!$route.query.id">
          <label class="label">Job Function <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Job Function" rules="required" v-slot="{ errors }">
              <selctJobFunction v-model="form.jobFunctionId" :updateText="jobFunctionInfo"
                :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field">
          <label class="label">Work Location <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Working Location" rules="required" v-slot="{ errors }">
              <SelectWorkLocation v-model="form.workingLocation" :info="workingLocationInfo" name="Working Location"
                :updateText="selectWorkingLocation" :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

      </div>

      <div class="grids is-2-desktop gap-20-desktop">
        <div class="field">
          <label class="label">Working Experience <span>*</span></label>
          <div class="control">
            <select v-model="form.workingExperience" class="input">
              <option v-for="(i, idx) in workingExperienceInfo" :key="idx" :value="i._id">
                {{ i.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Education Level <span>*</span></label>
          <div class="control">
            <select v-model="form.educationLevel" class="input">
              <option v-for="(i, idx) in educationLevelInfo" :key="idx" :value="i._id">
                {{ i.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="grids is-2-desktop gap-20-desktop">
        <div class="field">
          <label class="label">Preferred Language <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Preferred Language" rules="required" v-slot="{ errors }">
              <SelectLanguage v-model="form.preLanguage" :info="preLanguageInfo" name="Preferred Language"
                :updateText="selectPreLanguage" :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field">
          <label class="label">Salary / Show Salary <label class="switch">
              <input type="checkbox" v-model="form.isShowSalary" />
              <span class="slider round"></span>
            </label> <span>*</span></label>
          <div class="control">
            <select v-model="form.salaryRange" class="input">
              <option v-for="(i, idx) in salaryRageInfo" :key="idx" :value="i._id">
                {{ i.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="grids is-2-desktop gap-20-desktop">
        <div class="field">
          <label class="label">Job Level <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Job Level" rules="required" v-slot="{ errors }">
              <select v-model="form.jobLevelId" class="input" :class="{ error: errors[0] }">
                <option v-for="(i, idx) in jobLevelInfo" :key="idx" :value="i._id">
                  {{ i.name }}
                </option>
              </select>
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="field no-margin">
        <label class="label">Job Description <span>*</span></label>
        <div class="control">
          <ValidationProvider name="Job Descriptions" rules="required" v-slot="{ errors }">
            <div v-if="!isLoading">
              <FroalaEditor v-model="form.jobDescription" />
            </div>
            <FroalaEditor v-if="isLoading" v-model="form.jobDescription" />
            <!-- <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span> -->
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selctJobFunction from "../../others/selectJobFunction.vue"
import SelectLanguage from "../../others/multiSelect.vue";
// import SelectSalary from "../../others/normalSelect.vue";
// import SelectEducation from "../../others/normalSelect.vue";
// import SelectWorkingExperience from "../../others/normalSelect.vue";
import SelectWorkLocation from "../../others/multiSelect.vue";
import { GET_REUSE } from "@/graphql/manage/query";
import { apolloClient } from "@/services/apollo-client";
import FroalaEditor from "../../others/FroalaEditor";
export default {
  components: {
    selctJobFunction,
    SelectLanguage,
    // SelectSalary,
    // SelectEducation,
    // SelectWorkingExperience,
    FroalaEditor: FroalaEditor,
    SelectWorkLocation,
  },
  props: ["info", 'jobFunctionLoading'],
  data: () => ({
    form: {
      title: "",
      staffQTY: "1",
      jobFunctionId: [],
      workingLocation: [],
      workingExperience: "",
      jobLevelId: "",
      educationLevel: "",
      preLanguage: [],
      salaryRange: "",
      isShowSalary: true,
      jobDescription: ""
    },
    jobFunctionInfo: [],
    selectWorkingLocation: [],
    workingLocationInfo: [],
    workingExperienceInfo: [],
    educationLevelInfo: [],
    jobLevelInfo: [],
    preLanguageInfo: [],
    selectPreLanguage: [],
    salaryRageInfo: [],
    isLoading: true,
  }),
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit("input", val);
        }
      },
      immediate: true
    },
    info() {
      // handler(val) {
      //   if (val) {

      this.jobFunctionInfo = this.info.jobFunctionId

      this.form.title = this.info.title
      this.form.staffQTY = this.info.staffQTY
      this.selectWorkingLocation = this.info.workingLocation ? this.info.workingLocation : []
      this.form.workingExperience = this.info.workingExperience ? this.info.workingExperience : ""
      this.form.jobLevelId = this.info.jobLevelId ? this.info.jobLevelId : ""
      this.form.educationLevel = this.info.educationLevel ? this.info.educationLevel : ""
      this.selectPreLanguage = this.info.preLanguage ? this.info.preLanguage : []
      this.form.salaryRange = this.info.salaryRange ? this.info.salaryRange : ""
      this.form.isShowSalary = this.info.isShowSalary
      this.form.jobDescription = this.info.jobDescription ? this.info.jobDescription : ""
      if (this.form.jobDescription) this.isLoading = false
      if (!this.info.title) this.form.isShowSalary = true
      // }
      // },
      // immediate: true
    }
  },
  methods: {
    async fetchWorkingLocation() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "Province",
          page: 1,
          perPage: 50,
        },
      });
      this.workingLocationInfo = res.data.getReuse.reuseType.map((i) => {
        return {
          _id: i._id,
          name: i.name,
          check: false
        }
      })
    },
    async fetchWorkingExperience() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "JobExperience",
          page: 1,
          perPage: 50,
        },
      });
      this.workingExperienceInfo = res.data.getReuse.reuseType
      if (!this.form.workingExperience) this.form.workingExperience = this.workingExperienceInfo[0]._id
    },
    async fetchEductionLevel() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "Degree",
          page: 1,
          perPage: 20,
        },
      });
      this.educationLevelInfo = res.data.getReuse.reuseType
      if (!this.form.educationLevel) this.form.educationLevel = this.educationLevelInfo[0]._id
    },
    async fetchPreLanguage() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "Language",
          page: 1,
          perPage: 50,
        },
      });
      this.preLanguageInfo = res.data.getReuse.reuseType
    },
    async fetchSalaryRange() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "SalaryRange",
          page: 1,
          perPage: 50,
        },
      });
      this.salaryRageInfo = res.data.getReuse.reuseType
      if (!this.form.salaryRange) this.form.salaryRange = this.salaryRageInfo[0]._id
    },
    async fetchJobLevel() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          search: "",
          type: "JobLevel",
          page: 1,
          perPage: 50,
        },
      });
      this.jobLevelInfo = res.data.getReuse.reuseType
      // if (!this.form.jobLevelId) this.form.jobLevelId = this.jobLevelInfo[0]._id
    },
  },
  created() {
    this.fetchWorkingLocation()
    this.fetchWorkingExperience()
    this.fetchEductionLevel()
    this.fetchPreLanguage()
    this.fetchSalaryRange()
    this.fetchJobLevel()
  }
};
</script>

<style lang="scss" scoped></style>
